import React from 'react';
import SEO from '../components/SEO';
import PrivacyPolicyContent from '../components/PrivacyPolicyContent';
import '../styles/PrivacyPolicy.css';

const PrivacyPolicy = ({ language }) => {
  return (
    <div>
      <SEO
        title="Privacy Policy"
        description="Read Blue Nest Hotel's privacy policy to understand how we collect, use, and protect your personal information."
        url="/privacy-policy"
      />
      <PrivacyPolicyContent language={language} />
    </div>
  );
};

export default PrivacyPolicy;
